import React, { Component, Fragment } from 'react';
import { FaFileInvoice } from 'react-icons/fa';
import { Input, InputGroup } from 'reactstrap';
import { ArcaHttpClientAccount } from '../../../code/ArcaHttpClientAccount';
import { ArcaHttpClientInvoice } from '../../../code/ArcaHttpClientInvoice';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ArcaLink } from '../Fields/ArcaLink';
import { StatusBar } from '../StatusBar';
import { InvoiceModalPanel } from './InvoiceModalPanel';

export class AccountPanel extends Component {

    constructor(props) {
        super(props);

        var now = new Date();
        var today = new ArcaDate(now)


        this.state = {
            today,
            account: null,
            isError: false,
            statusText: null,
            invoice: null,
            amount: null,
            details: null
        };
    }

    async componentDidMount() {
        await this.getAccountDetails()
    }

    async getAccountDetails() {
        ArcaHttpSystem.Log(`Get Account Details`)

        await ArcaHttpClientAccount.GetByHolderAsync(
            this.props.ownerId,
            ((account) => this.setState({ account, statusText: null, isError: false })),
            (msg => this.setState({ statusText: msg, isError: false })),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    async onInvoiceClick(invoiceId) {
        await ArcaHttpClientInvoice.GetInvoice(
            invoiceId,
            (invoice => this.setState({ invoice })),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    async processPayment(accountId, amount, details) {
        ArcaHttpSystem.Log(`${accountId} ${amount} ${details} `)

        await ArcaHttpClientAccount.TakePaymentAsync(
            accountId, parseFloat(amount), details,
            (() => {
                ArcaHttpSystem.Log(`Now refreshing `)
                this.getAccountDetails(this);
            }),
            ((msg) => this.setState({ isError: true, statusText: msg })),
            ((msg) => this.setState({ isError: true, statusText: msg }))
        )
    }

    handlePaymentChange(e) {
        this.setState({ amount: e.target.value })
    }

    handleDetailsChange(e) {
        this.setState({ details: e.target.value })
    }

    async settleBalance(accountId) {
        ArcaHttpSystem.Log(`Calling SettleBalance '${accountId}'`)

        await ArcaHttpClientAccount.SettleBalance(accountId,
            ((account) => this.setState({ account, statusText: null, isError: false })),
            ((msg) => this.setState({ isError: true, statusText: msg })),
            ((msg) => this.setState({ isError: true, statusText: msg }))
        );
    }

    async confirmSettleBalance(accountId) {
        if (window.confirm(`Please confirm a payment of '${this.state.account.CurrencySymbol}${this.state.account.Balance.toFixed(2)}' has been made`))
            this.settleBalance(accountId)
        else
            this.setState({ statusText: 'Settled payment attempt was cancelled', isError: false })
    }

    render() {
        let { account, statusText, isError, invoice } = this.state;

        return (
            <Fragment>
                <h1>Account details</h1>
                <StatusBar message={statusText} isError={isError} />

                <h4>Balance: {account?.CurrencySymbol} {account?.Balance?.toFixed(2)}</h4>

                {ArcaSecurity.IsAdmin && account !== null
                    ? <InputGroup>
                        <span height={'37px'} addonType="prepend">
                            Credit or debit(-ve) account
                            </span>
                        <span height={'37px'} addonType="prepend">{account?.CurrencySymbol}</span>

                        <Input placeholder="Amount" min={0} max={999} type="number" step="0.01" onChange={this.handlePaymentChange.bind(this)} />
                        <Input placeholder="Detail" type="text" onChange={this.handleDetailsChange.bind(this)} />
                        {/*<InputGroupAddon addonType="append">*/}
                            <ArcaLink
                                color="secondary"
                                height={'37px'}
                                onClick={this.processPayment.bind(this, account.Id, this.state.amount, this.state.details)}
                                text='Apply' />
                        {/*</InputGroupAddon>*/}
                    </InputGroup>
                    : null
                }

                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Date</th>
                            {!ArcaHttpSystem.IsSmartphone
                                ? <th>Time</th>
                                : null}

                            {ArcaHttpSystem.IsSmartphone
                                ? <th>Amount</th>
                                : <Fragment>
                                    <th>Detail</th>
                                    <th>Credit</th>
                                 </Fragment>}

                            <th>Debit</th>
                            <th>Balance</th>
                            <th>Inv</th>
                        </tr>
                    </thead>
                    <tbody>
                        {account?.Transactions.map((t, k) =>
                            <tr key={k}>
                                <td>{t.Date.DateShortPretty}</td>
                                {!ArcaHttpSystem.IsSmartphone
                                    ? <td>{t.Date.Time}</td>
                                    : null}
                                <td>{t.Details}</td>

                                {ArcaHttpSystem.IsSmartphone
                                    ? <td>{(t.Debit ? '(' + account.CurrencySymbol + t.Debit.toFixed(2) + ')' : account.CurrencySymbol + t.Credit.toFixed(2))}</td>
                                    : <Fragment>
                                        <td>{(t.Credit ? account.CurrencySymbol + t.Credit.toFixed(2) : '-')}</td>
                                        <td>{(t.Debit ? account.CurrencySymbol + t.Debit.toFixed(2) : '-')}</td>
                                    </Fragment>}

                                <td>{account.CurrencySymbol + t.Balance?.toFixed(2)}</td>

                                {t.InvoiceId !== null && t.InvoiceId !== 0
                                    ? <td className='minilink'>
                                        <FaFileInvoice
                                            onClick={this.onInvoiceClick.bind(this, t.InvoiceId)} />
                                    </td>
                                    : <td>-</td>}

                            </tr>)}
                    </tbody>
                </table>

                {invoice
                    ? <InvoiceModalPanel
                        invoice={invoice}
                        account={account}
                        onClose={() => { this.setState({ invoice: null }); this.props.onUpdated() }} />
                    : null}

            </Fragment>
        );
    }
}